import React from "react";
import { Drawer, styled, Box } from "@mui/material";
import NavItems from './NavItems';
import aimaLogo from '../../assets/images/AIMA_Logo.png';

const DRAWER_WIDTH = 260;
const COLLAPSED_WIDTH = 70;

const StyledDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'isExpanded',
})(({ theme, isExpanded }) => ({
  width: isExpanded ? DRAWER_WIDTH : COLLAPSED_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  '& .MuiDrawer-paper': {
    width: isExpanded ? DRAWER_WIDTH : COLLAPSED_WIDTH,
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.paper,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    overflowY: 'auto', 
    paddingTop: theme.spacing(2),
    borderRight: `1px solid ${theme.palette.divider}`,
    '&::-webkit-scrollbar': { display: 'none' }, 
    msOverflowStyle: 'none', 
    scrollbarWidth: 'none', 
  },
}));

const SideNav = ({ isExpanded }) => {

  return (
    <StyledDrawer variant="permanent" isExpanded={isExpanded}>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        flexShrink: 0, 
        px: isExpanded ? 2 : 1,
        py: 1,
        mb: 2,
        height: 80, 
      }}>
        <img 
          src={aimaLogo} 
          alt="Logo"
          style={{
            maxWidth: '100%',
            height: 'auto',
            maxHeight: isExpanded ? 65 : 40,
            width: isExpanded ? 'auto' : 40, 
            objectFit: 'contain',
            borderRadius: '8px',
            transition: 'all 0.3s ease-in-out'
          }} 
        />
      </Box>

      <Box sx={{ flexGrow: 1, overflowY: 'auto', overflowX: 'hidden' }}>
        <NavItems drawerOpen={isExpanded} />
      </Box>
    </StyledDrawer>
  );
};

export default SideNav;